<template lang="pug">
  section.TourIntroduction
    .TourIntroduction_wrapper
      <h3 class="TourIntroduction_title">{{ title }}</h3>
      <p class="TourIntroduction_content">{{ content }}</p>
</template>

<script>

export default {
  props: ['title', 'content'],
  data () {
    return {}
  },
  mounted () {

  }
}

</script>

<style lang="stylus" scoped>
.TourIntroduction

  position relative
  padding 110px 40px
  background-color $beige-l
  text-align left

  &_wrapper

    max-width: 910px;
    margin auto

  p

    letter-spacing: 0;
    line-height: 40px;
    font-size 16px
    line-height 32px
    margin-top 30px

    @media $mq_m

      font-size 20px
      line-height 40px

  h3

    font-family $font
    letter-spacing: 1px;
    line-height: 30px;
    margin-bottom 0px
    font-size 20px

    @media $mq_m

      font-size 26px
      margin-bottom 0px
      line-height 36px
</style>
